<template>
  <div class="d-flex flex-column-fluid">
    <!--begin::Container-->
    <div class="container">
      <span style="position: absolute; top:-70px; right:0px; z-index: 10000">
        <button
          ref="refresh"
          :disabled="isBusy"
          class="btn btn-light font-weight-bolder font-size-sm mx-1"
          @click="submitsearch"
        >
          <i class="flaticon2-refresh"></i>Refresh
        </button>
      </span>
      <div class="row">
        <div
          class="col-xl-4 col-lg-6 col-md-6 col-sm-6"
          v-for="item in items.data"
          :key="item.ATGId"
        >
          <div class="card card-custom gutter-b card-stretch">
            <div class="card-header ribbon ribbon-top">
              <div
                class="ribbon-target bg-success"
                style="top: -2px; right: 20px;"
              >
                {{ item.Status }}
              </div>
              <div class="card-title">
                <h3 class="mb-0">{{ item.ATGClientId }}</h3>
              </div>
            </div>
            <div class="card-body pt-4 pb-0">
              <div class="mb-0">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-dark-75 text-muted mr-2">SeriesType:</span>
                  <span class="font-weight-bolder">{{ item.SeriesType }}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-dark-75 text-muted mr-2">RangeStart:</span>
                  <span class="font-weight-bolder">{{
                    item.RangeStart | numFormat("000000")
                  }}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-dark-75 text-muted mr-2">RangeEnd:</span>
                  <span class="font-weight-bolder">{{
                    item.RangeEnd | numFormat("000000")
                  }}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-dark-75 text-muted mr-2">Current:</span>
                  <span href="#" class="font-weight-bolder">{{
                    item.CurrentCount | numFormat("000000")
                  }}</span>
                </div>
              </div>
              <router-link
                :to="{
                  name: 'easyreceipt-atg-details',
                  params: { propdata: item }
                }"
              >
                <button
                  type="button"
                  class="btn btn-block btn-sm btn-link font-weight-bolder text-uppercase py-4"
                >
                  view details
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!--end::Row-->

      <!--begin::Pagination-->
      <div class="card card-custom">
        <div class="card-body pt-0 pb-2">
          <Paginator
            v-bind:currentPage="search.currentPage"
            v-bind:rowsPerPage="search.rowsPerPage"
            v-bind:totalRows="items.totalRows"
            @update-currentpage="
              value => {
                search.currentPage = value;
                this.submitsearch();
              }
            "
            @update-pagesize="
              value => {
                search.currentPage = 1;
                setPageSize(value);
              }
            "
          />
        </div>
      </div>
      <!--end::Pagination-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import Paginator from "@/view/content/widgets/paginator2.vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";

Vue.use(vueNumeralFilterInstaller);
Vue.use(require("vue-moment"));
Vue.filter("numFormat", numFormat(numeral));

export default {
  components: { Paginator },
  data() {
    return {
      isBusy: false,
      filters: {},
      options: {
        Users: []
      },
      search: {
        currentPage: 1,
        rowsPerPage: 6
      },
      items: {
        data: [],
        totalRows: 0,
        indexStart: 0
      }
    };
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser"]),
    config() {
      return this.layoutConfig();
    },
    currentPage() {
      return this.search.currentPage;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("ATG");
      this.submitsearch();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreceipt"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    setPageSize(value) {
      this.search.rowsPerPage = value;
      this.submitsearch();
    },
    submitsearch() {
      var self = this;
      self.isBusy = true;
      return new Promise(resolve => {
        let param = {
          currentPage: self.search.currentPage,
          rowsPerPage: self.search.rowsPerPage
        };
        this.$gtag.event("atg_search", {
          search_term: JSON.stringify(param)
        });
        ApiService.get("atg/search", param)
          .then(({ data }) => {
            self.items.data = data.Items;
            self.items.totalRows = data.TotalRows;
            self.items.indexStart =
              (self.search.currentPage - 1) * self.search.rowsPerPage;
            self.isBusy = false;

            window.scrollTo(0, 0);
            resolve(data);
            return data;
          })
          .catch(() => {
            self.items.data = [];
            self.items.totalRows = 0;
            self.isBusy = false;
            window.scrollTo(0, 0);
          });
      });
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      if (newValue != oldValue) {
        this.submitsearch();
      }
    }
  }
};
</script>
